export const LINK_STATUS = {
  PENDING_TERMS_ACCEPTANCE: 'PENDING_TERMS_ACCEPTANCE',
  CONNECTED: 'CONNECTED',
} as const;

export type LinkStatus = (typeof LINK_STATUS)[keyof typeof LINK_STATUS];

export interface BalanceBreakdown {
  checking: number;
  creditCollateral: number | null;
  taxBucket: number | null;
  total: number;
}

export interface Client {
  externalId: string;
  businessName: string;
  primaryOwner: string;
  latestStatementAvailable: boolean;
  lastStatementDate: string | null;
  linkStatus: LinkStatus;
  linkExternalId: string;
  checkingBalance: number;
  savingsBalance: number;
  balanceBreakdown: BalanceBreakdown | null;
}

export interface ClientsPageResponse {
  content: Client[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export interface ClientActionParams {
  accountantExternalId: string;
  referralExternalId: string;
}
